<template>
  <div class="fill-height d-flex flex-column">
    <v-hover v-slot="{ hover }">
      <v-card
        class="position-relative flex-grow-1 rounded-lg d-flex flex-column mb-2 item-card" light
        style="box-shadow: 0 4px 5px -1px rgba(0, 0, 0, .05); border: 1px solid rgba(0, 0, 0, .08)"
      >
        <div :class="{visible: hover}" class="d-flex flex-column pa-2 offscreen">
          <v-btn :to="`/${$store.state.merchant.slug}/item/${item.slug}`" class="mb-2" elevation="0" fab small>
            <v-icon color="grey" size="18">mdi-eye</v-icon>
          </v-btn>
          <v-btn class="mb-2" elevation="0" fab small>
            <v-icon color="red" size="18">mdi-heart</v-icon>
          </v-btn>
          <v-btn class="mb-2" elevation="0" fab small @click="add()">
            <v-icon color="green" size="18">mdi-cart-plus</v-icon>
          </v-btn>
        </div>
        <router-link :to="`/${$store.state.merchant.slug}/item/${item.slug}`"
                     class="border-bottom position-relative d-block">
          <template v-if="item.secondary_picture">
            <ProxyImage
              :src="item.secondary_picture"
              v-show="hover && item.secondary_picture && !item.secondary_picture.match(/undefined|null/gi)"
            />
          </template>
          <ProxyImage :src="item.primary_picture"
                      v-show="!hover || !item.secondary_picture || item.secondary_picture.match(/undefined|null/gi)"/>
          <div v-if="discount"
               class="d-flex flex-column align-center justify-center fill-width absolute bottom left mb-2">
            <v-chip class="px-2" color="blue" dark small>Save {{ discount.percentage }}%</v-chip>
            <div v-if="discount.end" class="d-flex mt-2">
              <v-card class="py-2 px-2 d-flex flex-column text-center" outlined>
                <div class="text-caption font-weight-bold">{{ timer.days }}</div>
                <div class="ma-0 pa-0 text-caption" style="line-height: 1">days</div>
              </v-card>
              <v-card class="py-2 px-2 ml-1 d-flex flex-column text-center" outlined>
                <div class="text-caption font-weight-bold">{{ timer.hours }}</div>
                <div class="ma-0 pa-0 text-caption" style="line-height: 1">hrs</div>
              </v-card>
              <v-card class="py-2 px-2 ml-1 d-flex flex-column text-center" outlined>
                <div class="text-caption font-weight-bold">{{ timer.minutes }}</div>
                <div class="ma-0 pa-0 text-caption" style="line-height: 1">mins</div>
              </v-card>
              <v-card class="py-2 px-2 ml-1 d-flex flex-column text-center" outlined>
                <div class="text-caption font-weight-bold">{{ timer.seconds }}</div>
                <div class="ma-0 pa-0 text-caption" style="line-height: 1">secs</div>
              </v-card>
            </div>
          </div>
        </router-link>
        <div v-if="$store.getters['cart/inCart'](item)" class="in-cart-indicator">
          <v-avatar color="green lighten-2" size="30">
            <v-icon color="white" small>mdi-cart-arrow-down</v-icon>
          </v-avatar>
        </div>
        <div class="px-3 py-3 px-md-4 flex-grow-1 d-flex flex-column align-start justify-center">
          <div :title="item.name" class="text-title black--text text-body-2 fill-width">{{ item.name }}</div>
          <v-rating
            :value="rating" background-color="orange lighten-3" color="orange" dense readonly size="15"
            v-if="$store.getters['merchant/theme'].show_product_ratings && $vuetify.breakpoint.mdAndUp"
          ></v-rating>
          <div class="d-flex justify-space-between fill-width border-top pt-2 mt-2 flex-grow-1 align-end">
            <div v-if="item.sell_on_credit === 1" class="text-title black--text text-body-2 font-weight-bold">
              <small v-if="discount" class="text-strikethrough mr-2 grey--text d-block text-smaller">
                {{ (item.credit_price || item.price) / item.no_of_months | currency }}
              </small>
              {{ monthly_amount | currency }}/mo • {{ item.no_of_months }} month(s)
            </div>
            <div v-if="item.sell_on_credit === 0" class="text-title black--text text-body-2">
              {{ price | currency }}
            </div>
          </div>
          <div v-if="item.quantity" class="mt-2 pt-2 border-top fill-width">
            <v-hover v-slot="{ hover }">
              <v-btn :outlined="!hover" block color="primary" elevation="0" small @click="add()">
                <v-icon left size="12">mdi-cart-plus</v-icon>
                Add to cart
              </v-btn>
            </v-hover>
          </div>
          <div v-else class="mt-2 pt-2 border-top fill-width">
            <v-chip class="px-2" color="red" dark x-small>Out of stock</v-chip>
          </div>
        </div>
      </v-card>
    </v-hover>
  </div>
</template>

<script>
import card from "../../../mixins/items/card";
import ProxyImage from "../../ProxyImage";

export default {
  name: "ItemCardDefault",
  components: { ProxyImage },
  mixins: [card],
}
</script>

<style lang="scss" scoped>

::v-deep {
  .offscreen {
    position: absolute;
    top: 0;
    right: -100px;
    transition: all .15s ease-in-out;
    z-index: 1;

    &.visible {
      right: 0
    }
  }
}

.item-card {
  transition: all .15s ease-in-out;

  &:hover {
    transform: scale(1.01) translateY(-10px);
  }
}
</style>
